module.exports = __webpack_public_path__ + "static/media/ic_btn_switch.9bec11c9.svg";